import React from "react";
import Link from "next/link";
import styles from "./SchoolEsteemedFaculties.module.css";
import Image from "next/image";
import { ArrowRight } from "lucide-react";
interface TileDescription {
  id: number;
  title: string;
  description: string;
}
interface FacultyCard {
  id: number;
  title_description: TileDescription;
  images?: any;
  name: string;
  title: string;
}
interface AllFacultiesLink {
  id: number;
  label: string;
  url: string;
}
interface EsteemedFaculties {
  id: number;
  title: string;
  all_faculties_link: AllFacultiesLink;
  faculty_cards: FacultyCard[];
}
interface Props {
  data: EsteemedFaculties;
}

const SchoolEsteemedFaculties: React.FC<Props> = ({ data }) => {
  return (
    <section className={styles.facultiesSection}>
      <div className={styles.facultyBg}></div>
      <div className="container">
        <div className={styles.facultyRow}>
          <div className={styles.header}>
            <h2>{data?.title}</h2>
            {/* <div className="d-none d-md-block">
              <Link
                href={data?.all_faculties_link?.url}
                className={`btn btn-outline-primary ${styles.allFacultiesLink}`}
              >
                {data?.all_faculties_link?.label}
                <span>
                  <FaArrowRight />
                </span>
              </Link>
            </div> */}
          </div>
          {/* This Static Data Only as of now  */}
          <div className="row">
            {data.faculty_cards.map((faculty) => (
              <div key={faculty.id} className="col-md-4">
                <div className={styles.facultyCard}>
                  <Image
                    src={faculty.images[0]?.url || ""}
                    alt={faculty.images[0]?.alternativeText}
                    title={faculty.images[0]?.alternativeText}
                    width={387}
                    height={320}
                    className={styles.facultyImage}
                  />
                  <h3>
                    {faculty.title_description?.title} <br />
                    <span className={styles.phdDes}>
                      {faculty.title_description?.description}
                    </span>
                  </h3>
                </div>
              </div>
            ))}
          </div>

          <div className="d-block d-md-none">
            <Link
              href={data?.all_faculties_link?.url}
              title={data?.all_faculties_link?.label}
              className={`btn btn-outline-primary ${styles.allFacultiesLink}`}
            >
              {data?.all_faculties_link?.label}
              <span>
                <ArrowRight />
              </span>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SchoolEsteemedFaculties;
